import React from 'react';

import { defaultErrorMessage } from '../../../constants/errorMessages';

import { SvgIcon } from '../../../design-system';
import RefreshCwIcon from '../../../design-system/Icons/RefreshCwIcon';

const MessageErrorBanner = ({
    errorMessage = defaultErrorMessage,
    handleRegenerate,
    isDisabled = false,
}) => {
    return (
        <button className="flex gap-2" disabled={isDisabled} onClick={handleRegenerate}>
            <SvgIcon color="#E95B69" icon={RefreshCwIcon} size="medium" />
            <p className="font-body text-body-regular-s text-red-500 break-words">{errorMessage}</p>
        </button>
    );
};

export default MessageErrorBanner;
